import { Component, OnInit, ViewChild } from '@angular/core';
import { CourseService } from 'src/app/services/course.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Course } from 'src/app/models/course';
import { TutorService } from 'src/app/services/tutor.service';
import { SupporterService } from 'src/app/services/supporter.service';
import { CategoryService } from 'src/app/services/category.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { VimeoService } from 'src/app/services/vimeo.service';
import { MediaService } from 'src/app/services/media.service';
import { TimeZoneService } from 'src/app/services/timezone.service';

@Component({
  selector: 'app-practice-content',
  templateUrl: './practice-content.component.html',
  styleUrls: ['./practice-content.component.scss']
})

export class PracticeContentComponent implements OnInit {
  public courseId;
  public course:Course;
  public courseLoaded:boolean=false;
  public courseForm: FormGroup;
  public Editor = ClassicEditor;
  public supporters=[];
  public tutors=[];
  public categories=[];
  public courseTutors=[];
  public courseSupporters=[];
  public courseCategories=[];
  @ViewChild("descriptionEditor", {static: false}) descriptionEditor:any;

    // TimeZone
    public DefaultTimeZone:boolean = true;
    public USATimeZone:boolean = false;


  constructor(
    private _course: CourseService,
    private _activeRoute: ActivatedRoute,
    private _tutor: TutorService,
    private _supporter: SupporterService,
    private _cat: CategoryService,
    private _router: Router,
    private _vimeo: VimeoService,
    private _media: MediaService,
    private timezoneService: TimeZoneService
  ) {
    this.courseId=this._activeRoute.snapshot.paramMap.get('id');
    this.courseForm = new FormGroup({
      title: new FormControl('',[Validators.required]),
      description: new FormControl('',[Validators.required]),
      points: new FormControl('',[Validators.required]),
      published: new FormControl('',[Validators.required]),
      tutors: new FormControl(''),
      supporters: new FormControl(''),
      categories: new FormControl('')
    });
  }

  public refreshThumb(vimeoId:number, mediaId:number){
    this._vimeo.getVimeoThumbnail(vimeoId).subscribe(
      (data:any) => {
        if(data.status=='ok' && mediaId != 1) {
          this._media.updateMediaUrl(mediaId,data.thumbnail).subscribe(
            res => {
              this.getCourse();
              //this._notify.showMessage('Thumbnail refreshed', 'OK');
            }
          );
        }
        if(data.status=='ok' && mediaId == 1) {
          this._media.addMediaUrl(data.thumbnail).subscribe(
            (res:any) => {
              if(res.id){
                this._course.updateMediaId(res.id, this.course.id).subscribe(res=>{
                  this.getCourse();
                });
              }
              //this._notify.showMessage('Thumbnail refreshed', 'OK');
            }
          );
        }
      }
    );
  }

  getCourse(){
    this._course.getCourse(this.courseId).subscribe(
      res=>{
        this.course=res;
        this.courseForm.get('title').setValue(this.course.title);
        this.courseForm.get('description').setValue(this.course.description);
        this.courseForm.get('points').setValue(this.course.points);
        this.courseForm.get('published').setValue(this.course.published);
        this.course.tutors.forEach(item => { this.courseTutors.push(item.tutor_id) });
        this.courseForm.get('tutors').setValue(this.courseTutors);
        this.course.supporters.forEach(item => { this.courseSupporters.push(item.supporter_id) });
        this.courseForm.get('supporters').setValue(this.courseSupporters);
        this.course.category.forEach(item => { this.courseCategories[item.id]=item.id; });
        this.courseForm.get('categories').setValue(this.courseCategories);
        this.courseLoaded=true;
      }
    );
  }

  public updateCourse(){
    if(!confirm('Confirm save changes?')) return;
    this.course.title=this.courseForm.get('title').value;
    this.course.description=this.courseForm.get('description').value;
    this.course.points=this.courseForm.get('points').value;
    this.course.published=this.courseForm.get('published').value;
    if (this.course.title==''){
      return;
      //return this._notify.showMessage('Course must have a title', 'OK');
    }
    // console.log(this.course, this.courseForm.get('supporters').value, this.courseForm.get('tutors').value, this.courseForm.get('categories').value);
    // return;
    this._course.updateCourse(this.course, this.courseForm.get('supporters').value, this.courseForm.get('tutors').value, this.courseForm.get('categories').value).subscribe(
      (res:Course) => {
        // console.log(res);
        this._router.navigate(['/practice']);
      }
    );
  }

  public deletePracticeContent(id:number){
    if(confirm('Delete this course and all associated lessons?')){
      this._course.deleteCourse(id).subscribe(
        res=>{
          this._router.navigate(['/practice']);
        }
      );
    }
  }

  ngOnInit() {

  this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
  this.USATimeZone = this.timezoneService.checkUSATimeZone();

    this.getCourse();
    this._supporter.getSupporters().subscribe(
      (data:any) => {
        this.supporters=data;
      }
    );
    this._tutor.getTutors().subscribe(
      (data:any) => {
        this.tutors=data;
      }
    );
    this._cat.getCategories().subscribe(
      res=>{
        this.categories=res;
      }
    );
  }

}
